import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/auth'
import Logo from '../components/Logo'
import { Btn, inputCls, labelCls } from '../components/ui'

/** Définir / changer son mot de passe. Cible des liens magiques et de récupération. */
export default function MotDePasse() {
  const { session, loading, isAdmin } = useAuth()
  const [p1, setP1] = useState(''); const [p2, setP2] = useState('')
  const [msg, setMsg] = useState(''); const [done, setDone] = useState(false); const [busy, setBusy] = useState(false)
  const [waited, setWaited] = useState(false)
  useEffect(() => { const t = setTimeout(() => setWaited(true), 2500); return () => clearTimeout(t) }, [])

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setMsg('')
    if (p1.length < 8) { setMsg('Le mot de passe doit contenir au moins 8 caractères.'); return }
    if (p1 !== p2) { setMsg('Les deux mots de passe ne correspondent pas.'); return }
    setBusy(true)
    const { error } = await supabase.auth.updateUser({ password: p1 })
    setBusy(false)
    if (error) { setMsg('Erreur : ' + error.message); return }
    setDone(true); window.history.replaceState(null, '', '/mot-de-passe')
  }

  const wrap = (children: React.ReactNode) => (
    <div className="min-h-screen bg-noir text-blanc flex items-center justify-center px-6">
      <div className="w-full max-w-sm"><div className="flex justify-center mb-10"><Logo /></div>{children}</div>
    </div>
  )

  if (loading || (!session && !waited)) return wrap(<p className="text-acier text-center">Vérification du lien…</p>)
  if (!session) return wrap(<>
    <h1 className="font-display text-3xl tracking-wide text-center mb-2">Lien invalide ou expiré</h1>
    <p className="text-acier text-sm text-center">Demandez un nouveau lien depuis la page de connexion (« Mot de passe oublié »).</p>
    <a href="/login" className="block text-center mt-8 bg-orange hover:bg-orange-hover py-3 rounded-sm uppercase tracking-widest text-sm font-bold">Aller à la connexion</a>
  </>)
  if (done) return wrap(<>
    <h1 className="font-display text-3xl tracking-wide text-center mb-2">Mot de passe enregistré</h1>
    <p className="text-acier text-sm text-center">Vous pourrez désormais vous connecter avec votre courriel et ce mot de passe.</p>
    <a href={isAdmin ? '/admin' : '/portail'} className="block text-center mt-8 bg-orange hover:bg-orange-hover py-3 rounded-sm uppercase tracking-widest text-sm font-bold">Accéder à mon espace</a>
  </>)
  return wrap(
    <form onSubmit={submit}>
      <h1 className="font-display text-3xl tracking-wide text-center mb-1">Choisir un mot de passe</h1>
      <p className="text-acier text-sm text-center mb-8">Compte : {session.user.email}</p>
      <label className={labelCls}>Nouveau mot de passe</label>
      <input className={inputCls + ' mb-4'} type="password" value={p1} onChange={e => setP1(e.target.value)} required minLength={8} autoComplete="new-password" />
      <label className={labelCls}>Confirmer</label>
      <input className={inputCls} type="password" value={p2} onChange={e => setP2(e.target.value)} required autoComplete="new-password" />
      {msg && <p className="text-red-300 text-sm mt-3">{msg}</p>}
      <Btn type="submit" disabled={busy} className="w-full mt-6 py-3">{busy ? 'Enregistrement…' : 'Enregistrer'}</Btn>
      <a href={isAdmin ? '/admin' : '/portail'} className="block text-center text-xs uppercase tracking-widest text-acier hover:text-orange mt-6">← Retour à mon espace</a>
    </form>
  )
}
